export default function RefreshIcon({ className }: { className?: string }) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_360_10527)">
        <rect width="32" height="32" rx="6" fill="white" fillOpacity="0.2" />
        <rect
          x="0.5"
          y="0.5"
          width="31"
          height="31"
          rx="5.5"
          stroke="white"
          strokeOpacity="0.6"
        />
        <path
          d="M9.33331 14.6667C9.33331 14.6667 10.67 12.8455 11.7559 11.7588C12.8418 10.6722 14.3424 10 16 10C19.3137 10 22 12.6863 22 16C22 19.3137 19.3137 22 16 22C13.2646 22 10.9567 20.1695 10.2345 17.6667M9.33331 14.6667V10.6667M9.33331 14.6667H13.3333"
          stroke="white"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_360_10527">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export const displayName = "RefreshIcon";
